import React from 'react';
import styled from "@emotion/styled";
import { Switch, Route, Redirect } from 'react-router-dom';
import { routeList } from "@/router";
import Page404 from '@/pages/page404';


function App() {
  return (
    <AppContainer>
      <Switch>
        <Redirect from='/' to='/activity/' exact />
        <Redirect from='/activity/linzhitaohua2022' to='/activity/linzhitaohua2022/intro' exact />
        {
          routeList.map((item,index)=>{
              return (<Route 
                  path={item.path} 
                  exact={item.exact}
                  render={item.render} 
                  key={index}
              />
          )})
        }
        <Route component={Page404}/>
      </Switch>
    </AppContainer>
  );
}

const AppContainer = styled.div`
  width: 100%;
  background-color: #fff;
`;
export default App;
